import React, { useRef } from 'react';
import styled from 'styled-components';
import image1 from '../images/1.jpeg';
import image2 from '../images/2.avif';
import image3 from '../images/3.jpg';

const SectionContainer = styled.div`
  width: 100%;
  padding: 50px 0;
  background-color: #000000;
  position: relative;
`;

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: 40px;
  font-size: 2.5rem;
  color: #ffffff;
  font-family: 'Roboto', sans-serif;
`;

const ScrollContainer = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const ImageContainer = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  gap: 20px;
  padding: 10px 0;
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

const ImageWrapper = styled.div`
  min-width: 300px;
  width: 300px;
  flex-shrink: 0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(255, 255, 255, 0.1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const Image = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;
  display: block;
`;

const ImageCaption = styled.div`
  padding: 15px;
  text-align: center;
  background-color: #121212;
  color: #ffffff;
  font-family: 'Roboto', sans-serif;
`;

const ScrollButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 10;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
  
  &:focus {
    outline: none;
  }
  
  &.left {
    left: 10px;
  }
  
  &.right {
    right: 10px;
  }
`;

const ImageSection = () => {
  const scrollContainerRef = useRef(null);
  
  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    const scrollAmount = 320; // Width of card + gap
    
    if (container) {
      if (direction === 'left') {
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  };
  
  return (
    <SectionContainer>
      <SectionTitle>Our Services</SectionTitle>
      <ScrollContainer>
        <ScrollButton className="left" onClick={() => scroll('left')}>
          &lt;
        </ScrollButton>
        <ImageContainer ref={scrollContainerRef}>
          <ImageWrapper>
            <Image src={image1} alt="Service 1" />
            <ImageCaption>Professional Consulting</ImageCaption>
          </ImageWrapper>
          <ImageWrapper>
            <Image src={image2} alt="Service 2" />
            <ImageCaption>Business Solutions</ImageCaption>
          </ImageWrapper>
          <ImageWrapper>
            <Image src={image3} alt="Service 3" />
            <ImageCaption>Strategic Planning</ImageCaption>
          </ImageWrapper>
          <ImageWrapper>
            <Image src={image1} alt="Service 4" />
            <ImageCaption>Market Analysis</ImageCaption>
          </ImageWrapper>
          <ImageWrapper>
            <Image src={image2} alt="Service 5" />
            <ImageCaption>Financial Planning</ImageCaption>
          </ImageWrapper>
          <ImageWrapper>
            <Image src={image3} alt="Service 6" />
            <ImageCaption>Growth Strategy</ImageCaption>
          </ImageWrapper>
        </ImageContainer>
        <ScrollButton className="right" onClick={() => scroll('right')}>
          &gt;
        </ScrollButton>
      </ScrollContainer>
    </SectionContainer>
  );
};

export default ImageSection;